import { AEMErrorMessage } from '../../models/aem/error-message.interface';
import * as ErrorMessageMocks from './error-messages';

export const ErrorMessages: AEMErrorMessage[] = [
  ErrorMessageMocks.MicromomentErrorMessage,
  ErrorMessageMocks.TrackerErrorMessage,
  ErrorMessageMocks.QuickLinksErrorMessage,
  ErrorMessageMocks.BenefitsErrorMessage,
  ErrorMessageMocks.SnapshotErrorMessage,
  ErrorMessageMocks.UpgradesErrorMessage,
  ErrorMessageMocks.BannerErrorMessage,
  ErrorMessageMocks.OffersErrorMessage,
  ErrorMessageMocks.PartnersErrorMessage,
  ErrorMessageMocks.FullPageErrorMessage,
  ErrorMessageMocks.StatusErrorMessageMocks,
  ErrorMessageMocks.AccountActivityErrorMocks,
  ErrorMessageMocks.SortFilterNoResultErrorMocks
];
